export const description =
  "TVA à 5,5 % 2026 : guide complet du taux réduit applicable aux travaux d'amélioration énergétique (article 278-0 bis A du CGI). Comparatif 5,5 % / 10 % / 20 %, travaux éligibles, attestation, pièges à éviter. Économie automatique de 14,5 points sans condition de ressources.";
